/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import {TButtonAppearance, TButtonSize} from '../Button';
import {Stack} from '../primitives';
import {EStackDirection, TPlacementX, TPlacementY} from '../types';
import * as S from './style';

type TActionButtonOption = {
  id: string | number;
  content: React.ReactNode;
  handler: TAnyFunction;
  props?: TAnyObject;
};

export type TButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  square?: boolean;
  appearance?: TButtonAppearance;
  size?: TButtonSize;
};

export type TProps = TButtonProps & {
  options: TActionButtonOption[];
  children: React.ReactNode;
  overlayPlacementX?: TPlacementX;
  overlayPlacementY?: TPlacementY;
  overlayClassName?: string;
};

type TOverlayProps = {
  options: TProps['options'];
  size: TButtonSize;
};

const Overlay = React.memo<TOverlayProps>(({options, size}) => (
  <>
    {options.map((item) => (
      <S.Option
        key={item.id}
        label={item.content}
        value={String(item.id)}
        onClick={item.handler}
        size={size}
        {...item.props}
      />
    ))}
  </>
));

Overlay.displayName = 'Overlay';

const ActionButton = React.memo<TProps>(
  ({
    disabled,
    options,
    appearance = 'primary',
    size = 'M',
    overlayPlacementX = 'right',
    overlayPlacementY = 'bottom',
    type = 'button',
    children,
    overlayClassName,
    ...props
  }) => (
    <S.Dropdown
      head={
        <S.Button {...props} disabled={disabled} size={size} appearance={appearance} type={type}>
          <Stack size="1" direction={EStackDirection.ROW} align="center">
            {children}
          </Stack>
        </S.Button>
      }
      disabled={disabled}
      overlay={<Overlay options={options} size={size} />}
      offsetY={4}
      placementX={overlayPlacementX}
      placementY={overlayPlacementY}
      overlayClassName={overlayClassName}
      overlayComponent={S.Overlay}
    />
  ),
);

export type {TActionButtonOption};
export {ActionButton};
/* eslint-enable react/jsx-props-no-spreading */
